import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { resetFrom, nextStep, updateSurvey, checkLastStep } from 'store/actions';
import { REGIONS } from 'constants/survey';

import StepperNav from 'components/StepperNav/StepperNav';

import pin from 'assets/images/pin.svg';

import Analytics from '../../utils/analytics';

const mapStateToProps = (state) => ({
  isLastStep: state.isLastStep,
  survey: state.survey
});

const mapDispatchToProps = (dispatch) => ({
  resetFrom: (prop) => dispatch(resetFrom(prop)),
  nextStep: () => dispatch(nextStep()),
  updateSurvey: (survey) => dispatch(updateSurvey(survey)),
  checkLastStep: () => dispatch(checkLastStep())
});

class Step4 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      region: ''
    };
  }

  componentDidMount() {
    const { survey, checkLastStep } = this.props;

    if (survey.region) {
      this.setState({region: survey.region});
    }

    checkLastStep();
  }

  handleSelection = (regionSelected) => {

    const filteredType = Analytics.removeAccentMarkAndUppercase(regionSelected);

    Analytics.pushData({
      eventCategory: 'recomendador starressa',
      eventAction: 'clic boton',
      eventLabel: `step4_region_${filteredType}`
    });
  }

  handleChange = (event) => {
    const { survey, resetFrom, updateSurvey } = this.props;
    const regionSelected = event.target.value;

    if (!survey.region.length) {
      // Update data from the last step
      const updatedSurvey = {
        ...survey,
        ...{region: regionSelected},
      };

      updateSurvey(updatedSurvey);
    } else if (survey.region !== regionSelected) {
      resetFrom({region: regionSelected});
    }

    this.setState({ region: regionSelected });
  };

  render() {
    const { t, isLastStep } = this.props;

    return (
      <section className="m-step">
        <div className="m-step__header">
          <h2 className="t-h2 m-step__title">{t('steps.step4.title')}</h2>
        </div>
        <div className="m-step m-step__content m-step4">
          <img src={pin} alt="location gps"/>
          <div className="form-group">
            <label htmlFor="region">{t('steps.step4.label')}</label>
            <select id="region" name="region" className="custom-select--starressa" value={this.state.region} onChange={this.handleChange}>
              <option value="" disabled="" className="option-hide">{t('steps.step4.placeholder')}</option>
              {
              Object.entries(REGIONS).map((item, index) => {
                return (
                  <option key={index} value={item[0]}>{item[0]}</option>
                );
              })
            }
            </select>
          </div>
        </div>
        <StepperNav
          disableNextBtn={(this.state.region === '')}
          onCLickNext={() => this.handleSelection(this.state.region)}
          showResultBtn={isLastStep} />
      </section>
    );
  }
}

const ConnectedStep4 = connect(mapStateToProps, mapDispatchToProps)(Step4);
export default withTranslation('translations')(ConnectedStep4);
